import React, { useState } from "react"
import Layout from "../components/layout"
import Seo from "../components/seo"
import WebriQForm from "../components/form/form"
import { Form } from "react-bootstrap"

const Contact = () => {
  const [tel, setTel] = useState("")
  const [errMessage, setErrMessage] = useState("")

  const normalizeInput = (value, previousValue) => {
    if (!value) return value
    const currentValue = value.replace(/[^\d]/g, "")
    const cvLength = currentValue.length

    if (!previousValue || value.length > previousValue.length) {
      if (cvLength < 4) return currentValue
      if (cvLength < 7)
        return `(${currentValue.slice(0, 3)}) ${currentValue.slice(3)}`
      return `(${currentValue.slice(0, 3)}) ${currentValue.slice(
        3,
        6
      )}-${currentValue.slice(6, 10)}`
    }
  }

  const onChange = e => {
    setTel(normalizeInput(e.target.value, tel))
    setErrMessage("")
  }

  const onFocusOut = e => {
    // console.log("it works")
    if (e.target.value.length < 14) {
      setTel("")
      setErrMessage("Please provide exact, (NXX) NXX-XXXX")
    }
  }
  return (
    <Layout>
      <Seo
        title="Contact Us"
        description="Contact information for Assured Assisted Living in Castle Rock CO"
      />
      <div className="page-headline blog-page">
        <div className="container">
          <div className="section-heading text-center">
            <h1>Contact Us</h1>
          </div>
        </div>
      </div>
      <div className="page-content menu">
        <div className="container">
          <div className="row justify-content-between">
            <div className="col-md-10 m-auto">
              <p className="mb-5">
                You can be assured of quality care as well as peace of mind
                knowing your family member will receive the comprehensive
                services, personal care, and emotional support, 24 hours a day.
              </p>
              <WebriQForm
                form_name="Contact Us Form"
                form_id="5ea005db6d4bd86beef0baaf"
                form_classname="contact-us"
                method="POST"
              >
                <div className="row">
                  <div className="col-12">
                    <div className="form-group">
                      <input
                        className="form-control"
                        type="text"
                        name="name"
                        placeholder="Name"
                        required
                      />
                    </div>
                    <div className="form-group">
                      <input
                        className="form-control"
                        type="email"
                        name="email"
                        placeholder="Email"
                        required
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <input
                        onChange={onChange}
                        onBlur={onFocusOut}
                        className="form-control"
                        type="text"
                        name="phone"
                        placeholder="Phone Number"
                        value={tel}
                        required
                      />
                      {errMessage && (
                        <p className="text-danger text-left">
                          <small> {errMessage}</small>
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group text-left">
                      <Form.Group
                        controlId="desiredlocation"
                        className="form-group input-select"
                      >
                        <Form.Control as="select" name="Desired Location?">
                          <option selected>Choose...</option>
                          <option value="Castle Rock">Castle Rock</option>
                          <option value="Centennial">Centennial</option>
                          <option value="Lakewood">Lakewood </option>
                          <option value="Littleton">Littleton </option>
                          <option value="Parker">Parker</option>
                        </Form.Control>
                      </Form.Group>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <textarea
                        className="form-control mb-2"
                        name="message"
                        placeholder="Message"
                        rows={3}
                        defaultValue={""}
                      />
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <div className="webriq-recaptcha" />
                    </div>
                  </div>
                  <div className="form-group w-100 px-3 mt-2">
                    <button className="hero-cta" type="submit">
                      Submit Now
                    </button>
                  </div>
                </div>
              </WebriQForm>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  )
}

export default Contact
